import { render, staticRenderFns } from "./img-input-autoload.vue?vue&type=template&id=384af007&"
import script from "./img-input-autoload.vue?vue&type=script&lang=js&"
export * from "./img-input-autoload.vue?vue&type=script&lang=js&"
import style0 from "./img-input-autoload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports